import cn from "classnames"
import React from "react"
import Spinner from "../../images/loading/aera-spinner.gif"
import "./SpinnerContainer.scss"

interface ISpinnerContainerProps {
    showSpinner: boolean
    className?: string
    wrapperClassName?: string
    children?: React.ReactNode
    maxHeight?: number
    minHeight?: number
}

export const SpinnerContainer = ({
    children,
    showSpinner,
    className,
    wrapperClassName,
    maxHeight,
    minHeight,
}: ISpinnerContainerProps) => {
    return (
        <div
            className={cn("swiipe-spinner-container clearfix", className)}
            style={
                showSpinner
                    ? {
                          ...(minHeight ? { minHeight: minHeight } : {}),
                          ...(maxHeight ? { maxHeight: maxHeight } : {}),
                      }
                    : {}
            }
        >
            <div className={cn("child-wrapper", { hide: showSpinner }, wrapperClassName)}>{children}</div>
            {showSpinner && <img className="spinner" src={Spinner} />}
        </div>
    )
}
